// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"4da32db1","453":"375405cb"}[chunkId] + ".chunk.js";
};